// Copyright 2015-2021 Swim inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {HtmlViewController} from "@swim/dom";
import type {TreeLimb} from "./TreeLimb";
import type {TreeLimbObserver} from "./TreeLimbObserver";

export class TreeLimbController<V extends TreeLimb = TreeLimb> extends HtmlViewController<V> implements TreeLimbObserver<V> {
  limbWillExpand(view: V): void {
    // hook
  }

  limbDidExpand(view: V): void {
    // hook
  }

  limbWillCollapse(view: V): void {
    // hook
  }

  limbDidCollapse(view: V): void {
    // hook
  }
}
